// extracted by mini-css-extract-plugin
module.exports = {"pintxo-expander-content":"ExpanderContent_pintxo-expander-content__E1oqz"};